import {Children, cloneElement} from 'react';

import {cn} from '../../lib/utils';

import type {ReactElement, ReactNode} from 'react';

export interface IllustrationProps {
  /** Width in pixels. Height is calculated automatically from the SVG's intrinsic aspect ratio unless explicitly set. */
  width: number;
  /** Height in pixels. When provided, overrides the intrinsic aspect ratio. */
  height?: number;
  children: ReactNode;
  className?: string;
}

export function Illustration({width, height, children, className}: IllustrationProps) {
  const child = Children.only(children) as ReactElement<{
    className?: string;
    style?: React.CSSProperties;
  }>;
  return cloneElement(child, {
    className: cn(height ? undefined : 'h-auto', child.props.className, className),
    style: {width, ...(height ? {height} : {}), ...child.props.style}
  });
}
